var render = function (_h,_vm) {var _c=_vm._c;return _c('v-list',{staticClass:"list-item",attrs:{"dark":""}},[_c('v-list-tile',_vm._g({attrs:{"ripple":""}},_vm.listeners),[_c('v-list-tile-avatar',[_c('v-icon',[_vm._v("arrow_back")])],1),_c('v-list-tile-title',{staticClass:"list-item__title"},[_vm._v(_vm._s(_vm.props.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }